import { ChordStepGrid } from './ChordStepGrid';
import type { ChordAccompaniment, ChordId } from '../types';

interface Props {
  open: boolean;
  measureIndex: number;
  bpm: number;
  accompaniment: ChordAccompaniment;
  activeStep: number | null;
  onClose: () => void;
  onAccompanimentChange: (next: ChordAccompaniment) => void;
  onToggleStep: (measureIndex: number, chordId: ChordId, stepIndex: number) => void;
  onExtendRange: (
    measureIndex: number,
    chordId: ChordId,
    fromStep: number,
    toStep: number,
  ) => void;
  onClearRow: (measureIndex: number, chordId: ChordId) => void;
}

export function MeasureChordPanel({
  open,
  measureIndex,
  bpm,
  accompaniment,
  activeStep,
  onClose,
  onAccompanimentChange,
  onToggleStep,
  onExtendRange,
  onClearRow,
}: Props) {
  if (!open) return null;

  const grid = accompaniment.measures[measureIndex];
  if (!grid) return null;

  return (
    <div className="drum-panel-backdrop" role="presentation" onClick={onClose}>
      <div
        className="drum-panel measure-chord-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="measure-chord-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="drum-panel__header">
          <div>
            <h2 id="measure-chord-title" className="drum-panel__title">
              Acordes · Compás {measureIndex + 1}
            </h2>
            <p className="drum-panel__subtitle">
              Piano eléctrico · toca el nombre del acorde para editar sus notas. Shift+clic alarga.
            </p>
          </div>
          <button type="button" className="drum-panel__close" onClick={onClose} aria-label="Cerrar">
            ×
          </button>
        </header>

        <div className="drum-panel__toolbar">
          <label className="drum-panel__toggle">
            <input
              type="checkbox"
              checked={accompaniment.enabled}
              onChange={(e) =>
                onAccompanimentChange({ ...accompaniment, enabled: e.target.checked })
              }
            />
            Usar acordes al reproducir
          </label>
        </div>

        <div className="drum-panel__grid-wrap">
          <ChordStepGrid
            grid={grid}
            accompaniment={accompaniment}
            bpm={bpm}
            activeStep={activeStep}
            onAccompanimentChange={onAccompanimentChange}
            onToggleStep={(chordId, step) => onToggleStep(measureIndex, chordId, step)}
            onExtendRange={(chordId, from, to) => onExtendRange(measureIndex, chordId, from, to)}
            onClearRow={(chordId) => onClearRow(measureIndex, chordId)}
          />
        </div>

        <footer className="drum-panel__footer">
          <p className="drum-panel__hint">
            Clic en una celda suena al instante. Mantén Shift y clic en otra celda de la misma fila para alargar.
          </p>
          <button type="button" className="btn btn-play" onClick={onClose}>
            Listo
          </button>
        </footer>
      </div>
    </div>
  );
}
